import { mapGetters } from "vuex";
import announcements from "@/frame/messages/mixins/announcements.js";
import uisettings from "@/frame/theme/mixins/uisettings.js";

export default {
  mixins: [announcements, uisettings],
  computed: {
    // eslint-disable-next-line
    ...mapGetters([
      "getUser",
      "getDetailLink",
      "getDetailBasic"
    ])
  },
  methods: {
    defineLinkSourceDocument() {
      let link = this.getDetailLink;
      // SOURCE
      link.st = this.getDetailBasic.title;
      link.sid = this.getDetailBasic.id;
      link.sidg = this.getDetailBasic.idg;
      link.sdid = this.getDetailBasic.did;
      link.stag = this.getDetailBasic.tag;
      // FACILITY
      if (
        this.getUser.pref.select.fdid !== null &&
        this.getUser.pref.select.fdid !== undefined &&
        this.getUser.pref.select.fdid !== ""
      ) {
        link.ft = this.getUser.pref.select.fname;
        link.fid = this.getUser.pref.select.fid;
        link.fdid = this.getUser.pref.select.fdid;
        link.sidg = this.getUser.pref.select.fidg;
      }
      return link;
    },
    resetLinkAppendedProcedure() {
      let link = this.getDetailLink;
      let pri = this.getDetailLink.wpt;
      let id = this.getDetailLink.wpid;
      if (this.getDetailLink.wpt !== "") {
        link.wpid = "";
        link.wpdid = "";
        link.wpt = "";
        link.wpidg = "";
        link.wprev = "";
        this.$store.dispatch("changeDetailLink", link);
        if (pri !== "") {
          let msg = "Procedure " + id + " was removed.";
          this.generateInfoSnackbar(this.ui.btnColorGrey, msg);
        }
      }
    },
    resetLinkAppendedProgram() {
      console.log("");
      console.log(">>> RESULTS LIST RESET <<<");
      let link = this.getDetailLink;
      let pri = this.getDetailLink.ept;
      let id = this.getDetailLink.epid;
      if (this.getDetailLink.ept !== "") {
        link.epid = "";
        link.epdid = "";
        link.ept = "";
        link.epidg = "";
        link.eprev = "";
        this.$store.dispatch("changeDetailLink", link);
        if (pri !== "") {
          let msg = "Results " + id + " was removed.";
          this.generateInfoSnackbar(this.ui.btnColorGrey, msg);
        }
      }
    }
  }
};
